import { Breakpoint, Link, useMediaQuery, useTheme } from '@mui/material';

interface IMobileOnlyLink {
	href: string;
	text: string;
	breakpoint?: Breakpoint;
}

/**
 * Helper component to (typically) work with phone number links
 * Renders a link if on mobile, otherwise just renders the text in bold
 * @param href - The URL or phone number to link to (e.g., 'tel:1234567890')
 * @param text - The text to display for the link
 * @param breakpoint - The breakpoint at which the link should STOP being displayed (default is 'sm')
 * @example <>Call us on <MobileOnlyLink href="tel:1234567890" text="Call Us" breakpoint="md" />.</>
 */
const MobileOnlyLink = ({ href, text, breakpoint = 'sm' }: IMobileOnlyLink) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down(breakpoint));

	return <>{isMobile ? <Link href={href}>{text}</Link> : <b>{text}</b>}</>;
};

export default MobileOnlyLink;
